import { compact } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import RecipientIcon from './RecipientIcon';
import RecipientLabel from './RecipientLabel';
import Wrapper from './Wrapper';

function RecipientCount({ count, maxCount }) {
  const warningModifier = count > maxCount && 'warning';
  return (
    <Wrapper>
      <RecipientLabel modifiers={compact([warningModifier])}>
        {count}/{maxCount}
      </RecipientLabel>
      <RecipientIcon name="users" />
    </Wrapper>
  );
}

RecipientCount.propTypes = {
  count: PropTypes.number,
  maxCount: PropTypes.number.isRequired,
};

RecipientCount.defaultProps = {
  count: 0,
};

export default RecipientCount;



// WEBPACK FOOTER //
// ./compositions/NotesWidget/NoteCreator/RecipientCount/index.js